import {
  NOTIFICATION_BADGE_MAX,
  NOTIFICATION_CHANNEL_LABELS,
  NOTIFICATION_READ_FILTERS,
  NOTIFICATION_TYPE_LABELS,
  NOTIFICATION_TYPES,
} from 'constants/notifications';

export const formatNotificationCount = (count) => {
  const normalizedCount = Number(count) || 0;

  if (normalizedCount > NOTIFICATION_BADGE_MAX) {
    return `${NOTIFICATION_BADGE_MAX}+`;
  }

  return String(normalizedCount);
};

export const serializeNotificationReadFilter = (value) => {
  if (value === NOTIFICATION_READ_FILTERS.UNREAD) {
    return 'false';
  }

  if (value === NOTIFICATION_READ_FILTERS.READ) {
    return 'true';
  }

  return undefined;
};

export const getNotificationTypeLabel = (type) => (
  NOTIFICATION_TYPE_LABELS[type] || 'Notification'
);

export const getNotificationChannelLabel = (channel) => (
  NOTIFICATION_CHANNEL_LABELS[channel] || 'Unknown channel'
);

export const getNotificationTarget = (notification) => {
  const entities = notification?.entities || {};

  if (entities.reminderId) {
    return {
      label: 'Open reminder',
      path: `/reminders/edit?id=${entities.reminderId}`,
    };
  }

  if (entities.todoId) {
    return {
      label: 'Open todo',
      path: `/todos/edit?id=${entities.todoId}`,
    };
  }

  if (entities.workerId) {
    return {
      label: 'Open worker',
      path: `/workers/view?id=${entities.workerId}`,
    };
  }

  return {
    label: 'View notifications',
    path: '/notifications',
  };
};

export const sortNotificationsForPreview = (items = []) => {
  const priority = {
    [NOTIFICATION_TYPES.ERROR]: 0,
    [NOTIFICATION_TYPES.WARNING]: 1,
    [NOTIFICATION_TYPES.INFO]: 2,
  };

  return [...items].sort((left, right) => {
    const typeDifference = (priority[left?.type] ?? 3) - (priority[right?.type] ?? 3);

    if (typeDifference !== 0) {
      return typeDifference;
    }

    return new Date(right?.createdAt || 0).getTime() - new Date(left?.createdAt || 0).getTime();
  });
};
